import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Echeance } from '../model/echeance';

@Injectable({
    providedIn: 'root'
  })
  export class EcheanceService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    getEcheanceListByNumDossier(numDossier)
    {
        return this._restClientService.load<Echeance[]>('echeance/echeancelist-by-numdossier?numDossier='+numDossier);
    }


}
